<template>
  <div>
    <forms title=""
          :showBackButton="selectedTab === 0"
          :showSaveButton="selectedTab === 0"
          :showHelp="true" helpUrl="https://static.zopone.com.br/manuals/CadastroItemPCI.pdf"
          v-on:Back="onClearForm"
          v-on:Save="onSaveForm">

      <div class="form-group row">
        <div class="col-md-12 mb-3">
          Pais: <strong>{{data.pais}}</strong>
        </div>
        <div class="col-md-1 mb-3 pr-0">
          <label for="txtCodigo">{{$lang.PCI.Items.LabelCode}}</label>
          <b-form-input type="number"
                        name="txtCodigo"
                        v-model="form.codigo.value"
                        v-if="form.codigo.value > 0"
                        disabled />

          <b-form-input type="text"
                        class="text-bold text-center px-1"
                        :value="$lang.PCI.Items.NewCode"
                        v-else
                        disabled />
        </div>
        <div class="col-md-11 mb-3 pl-1">
          <label for="txtDescricao"><small v-if="form.descricao.required">* </small>{{$lang.PCI.Items.LabelDescription}}:</label>
          <b-form-input type="text"
                        name="txtDescricao"
                        ref="descricaoComp"
                        :placeholder="$lang.PCI.Items.PlaceholderDescription"
                        v-model="form.descricao.value"
                        :required="form.descricao.required"
                        :state="form.descricao.state" />
        </div>
        <!-- <div class="d-flex col-md-2 mb-3 align-items-end">
          <b-form-group>
            <b-form-checkbox v-model="form.resumo.value"
                             name="chkResumo"
                             :required="form.resumo.required"
                             :state="form.resumo.state"
                             switch>
              {{$lang.PCI.Items.LabelResume}}
            </b-form-checkbox>
          </b-form-group>
        </div> -->
        <b-tabs class="col-md-12" content-class="mt-3 mx-0" v-model="selectedTab" pills>
          <b-tab :title="$lang.PCI.Items.Tabs.General" active>
            <div class="col-md-12 mb-4 px-0">
              <div class="d-flex flex-row">
                <b-form-checkbox
                        v-model="form.mostrarPci.value"
                        switch
                        class="mb-4">* {{$lang.PCI.Items.LabelShowInPci}}</b-form-checkbox>
                <b-form-checkbox
                        v-if="isAdministrator"
                        v-model="form.itemFinanc.value"
                        switch
                        class="pl-5 mb-4">* {{$lang.PCI.Items.LabelFinancialItem}}</b-form-checkbox>
              </div>

              <b-form-group>
                <template #label>
                  <label for="radTipo"><small v-if="form.tipo.required">* </small>{{$lang.PCI.Items.LabelType}}:</label>
                </template>
                <b-form-radio-group v-model="form.tipo.value"
                                    name="radTipo"
                                    :options="form.tipo.options"
                                    :required="form.tipo.required"
                                    :state="form.tipo.state"
                                    :disabled="used">
                </b-form-radio-group>
              </b-form-group>
            </div>

            <!-- Dado -->
            <div class="col-md-12 mb-3" v-if="form.tipo.value === 0">
              <b-form-checkbox
                      v-model="form.itemLinhaPrincipal.value"
                      switch
                      class="mb-4">* {{$lang.PCI.Items.LabelPrincipalLineItem}}</b-form-checkbox>

              <b-form-group>
                <template #label>
                  <label for="radTipoDados"><small v-if="form.tipoDados.required">* </small>{{$lang.PCI.Items.LabelDataType}}:</label>
                </template>
                <b-form-radio-group v-model="form.tipoDados.value"
                                    name="radTipoDados"
                                    :options="form.tipoDados.options"
                                    :state="form.tipoDados.state"
                                    :disabled="used">
                </b-form-radio-group>
              </b-form-group>
            </div>

            <!-- Dado - Texto -->
            <div class="col-md-4 mb-3" v-if="form.tipo.value === 0 && form.tipoDados.value === 0">
              <b-form-group>
                <template>
                  <label for="tamanhoText"><small v-if="form.tamanhoTexto.required">* </small>{{ $lang.PCI.Items.LabelSize }}:</label>
                </template>
                <b-form-input v-model="form.tamanhoTexto.value"
                              type="number"
                              :required="form.tamanhoTexto.required"
                              name="tamanhoTexto"
                />
              </b-form-group>
            </div>

            <!-- Dado - Data -->
            <div class="col-md-12 mb-3 mt-3 p-0" v-if="form.tipo.value === 0 && form.tipoDados.value === 1">
              <b-form-group class="col-md-4">
                <template>
                  <label for="bloqueiaRetroativo"><small v-if="form.bloqueiaRetroativo.required"></small>{{ $lang.PCI.Items.RetroactiveDateLabel }}:</label>
                </template>
                <b-form-checkbox
                      v-model="form.bloqueiaRetroativo.value"
                      switch>* {{$lang.PCI.Items.RetroactiveDate}}</b-form-checkbox>
              </b-form-group>
              <b-form-group  class="col-md-2" v-show="form.bloqueiaRetroativo.value">
                <template>
                  <label for="ml-5 qtdDiasRetroativo"><small v-if="form.qtdDiasRetroativo.required"></small>{{ $lang.PCI.Items.RetroactiveDateDaysLabel }}:</label>
                </template>
                <b-form-input v-model="form.qtdDiasRetroativo.value"
                              type="number"
                              min="0"
                              :required="form.qtdDiasRetroativo.required"
                              name="qtdDiasRetroativo"
                />
              </b-form-group>
            </div>

            <!-- Dado - Valores -->
            <div class="col-md-12 mb-3 p-0" v-if="form.tipo.value === 0 && form.tipoDados.value === 6">
              <div class="d-flex flex-column">
                <div v-for="(val, index) in form.valores.value"
                    :key="index"
                    class="d-flex flex-wrap">
                  <div id="values" class="d-flex flex-row align-items-center col-md-8">
                    <b-input v-model="val.valor" :style="{'background-color': (val.cor ? val.cor : '#FFFFFF'), 'color': val.cor && val.fonteClara ? '#FFFFFF' : '#000000'}" class="mr-2"/>
                    <div class="action-buttons">
                      <b-dropdown href="#"
                                  variant="link"
                                  toggle-class="text-decoration-none p-0"
                                  no-caret
                                  tabindex="-1"
                                  v-b-tooltip.hover
                                  :title="$lang.Common.Tooltip.ButtonDelete">
                        <template #button-content>
                          <i class="fa fa-trash text-danger p-1"
                            style="cursor:pointer">
                          </i>
                        </template>
                        <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
                        <b-dropdown-item href="#" v-on:click="onRemoveValue(index)">{{$lang.Common.Yes}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
                      </b-dropdown>
                      <span v-if="!val.cor"
                            @click="onAddValueColor(val)"
                            style="cursor:pointer; font-size:1rem;"
                            v-b-tooltip.hover
                            :title="$lang.PCI.Items.Tooltip.AddColor">
                        <i class="fas fa-palette text-primary p-1"></i></span>
                    </div>
                  </div>
                  <div v-if="val.cor" class="d-flex flex-row align-items-center col-md-4">
                    <b-form-input v-model="val.cor" type="color" style="width: 100px;"></b-form-input>
                    <span v-b-tooltip.hover
                          @click="onRemoveValueColor(val)"
                          style="cursor:pointer; font-size:1rem;"
                          :title="$lang.PCI.Items.Tooltip.RemoveColor">
                      <i class="fas fa-times text-danger p-1"></i>
                    </span>
                    <b-form-checkbox v-model="val.fonteClara" switch class="ml-3">{{$lang.PCI.Items.LabelLightFont}}</b-form-checkbox>
                  </div>
                </div>

                <div class="d-flex flex-row align-items-center py-1">
                  <b-input :placeholder="$lang.PCI.Items.PlaceholderValues" v-model="newValue" class="mr-2"/>
                  <i class="fa fa-plus-circle text-third p-1"
                    style="cursor:pointer; font-size:1rem;"
                    @click="onAddValue">
                  </i>
                </div>
              </div>
            </div>

            <!-- Composto -->
            <div class="d-flex justify-content-around" style="width: 100%;" v-if="form.tipo.value === 1">
              <div class="d-flex flex-column col-md-5">
                <label>{{ $lang.PCI.Items.LabelChildrens }}:</label>
                <b-form-select multiple
                               :select-size="10"
                               class="h-100"
                               id="items-composto"
                               v-model="itemsAddSelected"
                >
                  <b-form-select-option v-for="(item, key) in form.children.options"
                                        :key="key"
                                        :value="item"
                  >
                    {{ item.descricao }}
                  </b-form-select-option>
                </b-form-select>
              </div>

              <div class="d-flex flex-column col-md-2">
                <div class="d-flex flex-column justify-content-center pt-3">
                  <b-button variant="light" class="mt-4" @click="addComposto">
                    <i class="fas fa-chevron-right"></i>
                  </b-button>

                  <b-button variant="light" class="mt-2" @click="removeComposto">
                    <i class="fas fa-chevron-left"></i>
                  </b-button>
                </div>
              </div>

              <div class="d-flex flex-column col-md-5">
                <label>{{ $lang.PCI.Items.LabelSelectedItems }}:</label>
                <b-form-select multiple
                               :select-size="10"
                               class="w-100 h-100"
                               id="items-selecionado-composto"
                               v-model="itemsRemoveSelected"
                >
                  <b-form-select-option v-for="(item, key) in form.children.value"
                                        :key="key"
                                        :value="item"
                  >
                    {{ item.descricao }}
                  </b-form-select-option>
                </b-form-select>
              </div>
            </div>

            <!-- Item COP -->
            <div class="col-md-10 mb-3" v-if="form.tipo.value === 2">
              <label for="dict-view">{{ $lang.PCI.Items.LabelCopItem }}</label>
              <v-select name="dict-view" :options="form.dfdID.options" label="nome"
                            :state="form.dfdID.state"
                            :reduce="dfd => dfd.id"
                            v-model="form.dfdID.value"
              />
            </div>

            <!-- Fórmula -->
            <div class="col-md-10 mb-3" v-if="form.tipo.value === 4">
              <label for="dict-view">{{ $lang.PCI.Items.LabelFormula }}</label>
              <div class="align-items-center d-flex flex-row pl-0 pb-1" v-for="(item, key) in form.formula.value" :key="key">
                <b-form-input v-model="item.dfd.nome" disabled />
                <i class="fa fa-times text-third pl-2 ml-auto text-danger"
                  style="cursor: pointer; font-size: 1rem;"
                  @click="onRemoveFormula(key)"
                />
              </div>
              <div class="align-items-center pl-0">
                <v-select name="dict-view"
                               :options="form.dfdID.options" label="nome"
                               :reduce="dfd => dfd.id"
                               @input="onAddFormula"
                               v-model="newFormula"/>
              </div>
            </div>

             <!-- Fórmula Smart -->
            <div class="col-md-10 mb-3" v-if="form.tipo.value === 9" >
              <label for="dict-view">{{ $lang.PCI.Items.LabelDict }}</label>
              <div class="align-items-center d-flex flex-row pl-0 pb-1" v-for="(item, key) in form.formulaSmart.value" :key="key">
                <b-form-input v-model="item.nome" disabled></b-form-input>
                <i class="fa fa-times text-third pl-2 ml-auto text-danger"
                  style="cursor: pointer; font-size: 1rem;"
                  @click="onRemoveFormulaSmart(key)"
                />
              </div>
              <div class="align-items-center pl-0">
                <v-select name="dict-view"
                               :options="form.pciDicItemID.options" label="nome"
                               :reduce="dic => dic.id"
                               @input="onAddFormulaSmart"
                               v-model="newFormulaSmart"/>
              </div>
            </div>

            <!-- Espelho -->
            <div class="col-md-8 mb-3" v-if="form.tipo.value === 3">
              <label>{{ $lang.PCI.Items.LabelMirror }}</label>
              <div class="d-flex align-items-center">
                <b-form-input class="mr-3" disabled v-model="getMirrorDescription"></b-form-input>
                <i style="font-size: 15px; cursor: pointer;"
                   class="fas fa-search text-third"
                   v-if="!showMirrorTreeview"
                   @click="onShowMirrorTreeview"
                   v-b-tooltip.hover :title="$lang.PCI.Items.SearchItem"></i>
                <i style="font-size: 15px; cursor: pointer;"
                   class="fas fa-times text-third"
                   v-if="showMirrorTreeview"
                   @click="showMirrorTreeview = false"
                   v-b-tooltip.hover :title="$lang.Common.Cancel"></i>
              </div>
              <div style="height: 500px;" class="mt-1" v-show="showMirrorTreeview">
                <item-tree-view ref="mirrorTreeview"
                                :list="form.pciModeloItemIDEspelho.options"
                                :serializer="it => `(${it.code}) ${it.name}`"
                                v-on:selectitem="onSelectMirrorItem" />
              </div>
            </div>
            <div class="col-md-12 d-flex flex-wrap" v-if="form.tipo.value === 3">
              <div class="col-md-3">
                <label>{{'Tipo de Espelho'}}</label>
                <b-form-select v-model="form.tipoEspelho.value"
                              :options="form.tipoEspelho.options"
                              :required="form.tipoEspelho.required"
                              :state="form.tipoEspelho.state"
                              @change="form.pciModeloItemIDEspelhoCond.required = form.tipoEspelho.value === 1">
                </b-form-select>
              </div>
              <div class="col-md-3" v-if="form.tipoEspelho.value === 1">
                <label>{{'Tipo de Condição'}}</label>
                <b-form-select v-model="form.tipoEspelhoCond.value"
                              :options="form.tipoEspelhoCond.options"
                              :required="form.tipoEspelhoCond.required"
                              :state="form.tipoEspelhoCond.state">
                </b-form-select>
              </div>
              <div class="col-md" v-if="form.tipoEspelho.value === 1">
                <label>{{'Item de Agrupamento da Condição'}}</label>
                <div class="d-flex align-items-center">
                  <b-form-input class="mr-3" disabled v-model="getMirrorCondDescription" :state="form.pciModeloItemIDEspelhoCond.state" />
                  <i style="font-size: 15px; cursor: pointer;"
                     class="fas fa-search text-third"
                      v-if="!showCondMirrorTreeview"
                     @click="onShowCondMirrorTreeview"
                     v-b-tooltip.hover :title="$lang.PCI.Items.SearchItem"></i>
                  <i style="font-size: 15px; cursor: pointer;"
                     class="fas fa-times text-third"
                     v-if="showCondMirrorTreeview"
                     @click="showCondMirrorTreeview = false"
                     v-b-tooltip.hover :title="$lang.Common.Cancel"></i>
                </div>
                <div style="height: 500px;" class="mt-1" v-show="showCondMirrorTreeview">
                  <item-tree-view ref="condMirrorTreeview"
                                  :list="form.pciModeloItemIDEspelhoCond.options"
                                  :serializer="it => `(${it.code}) ${it.name}`"
                                  v-on:selectitem="onSelectCondMirrorItem" />
                </div>
              </div>
            </div>

            <!-- AT -->
            <div class="col-md-12 d-flex flex-w" v-if="form.tipo.value === 5">
              <div class="col-md-6 mb-3">
                <label class="mb-1">{{'Campo'}}</label>
                <b-form-select ref="selectTipoAT"
                               v-model="form.tipoAT.value"
                               :options="form.tipoAT.options"
                               :required="form.tipoAT.required"
                               :state="form.tipoAT.state">
                </b-form-select>
                <label class="mt-2 mb-1">{{$lang.PCI.Items.ServiceAT}}</label>
                <div class="align-items-center d-flex flex-row pl-0 pb-1" v-for="(item, key) in form.servicosAt.value" :key="key">
                  <b-form-input v-model="item.servicoAnaliseTec.descricao" disabled />
                  <i class="fa fa-times text-third pl-2 ml-auto text-danger"
                    style="cursor: pointer; font-size: 1rem;"
                    @click="onRemoveServiceTecAn(key)"
                  />
                </div>
                <div class="align-items-center pl-0">
                  <v-select name="serviceTecAn-view" ref="selectServiceAT"
                            :options="form.servicosAt.options"
                            label="descricao"
                            :reduce="srv => srv.id"
                            @input="onAddServiceTecAn"
                            v-model="newServiceTecAn"/>
                </div>
              </div>
            </div>

            <!-- Paralisação -->
            <div class="col-md-12 d-flex flex-wrap" v-if="form.tipo.value === 6">
              <div class="col-md-6 mb-3">
                <label>{{'Campo'}}</label>
                <b-form-select v-model="form.tipoParalisacao.value"
                              :options="form.tipoParalisacao.options"
                              :required="form.tipoParalisacao.required"
                              :state="form.tipoParalisacao.state">
                </b-form-select>
              </div>

              <!-- OrigemDatasParalisacao -->
              <div class="col-md-6 mb-3" v-if="form.tipoParalisacao.value === 1">
                <label>{{'Origem Datas'}}</label>
                <b-form-select v-model="form.origemDatasParalisacao.value"
                              :options="form.origemDatasParalisacao.options"
                              :required="form.origemDatasParalisacao.required"
                              :state="form.origemDatasParalisacao.state">
                </b-form-select>
              </div>

              <!-- Items -->
              <div class="d-flex flex-wrap w-100" v-if="form.tipoParalisacao.value === 1 && form.origemDatasParalisacao.value === 1">
                <div class="d-flex col-md-12 p-0 m-0">
                  <div class="d-flex flex-grow-1">
                    <div class="col-md-6 p-0 px-2">
                      <label>{{ 'Início da Obra' }}</label>
                    </div>
                    <div class="col-md-6 p-0 px-2">
                      <label>{{ 'Término da Obra' }}</label>
                    </div>
                  </div>
                  <div style="width: 50px;" class="px-2"></div>
                </div>
                <div class="d-flex col-md-12 p-0 m-0 mb-1" v-for="(paralisacao, index) in form.paralisacoes.value" :key="index">
                  <div class="d-flex flex-grow-1">
                    <div class="d-flex col-md-6 p-0 px-2 align-items-center">
                      <div class="form-control" style="background-color: lightgreen;">
                        {{ paralisacao.pciModeloItemInicio ? paralisacao.pciModeloItemInicio.pais + ' > ' + paralisacao.pciModeloItemInicio.descricao : '' }}
                      </div>
                    </div>
                    <div class="d-flex col-md-6 p-0 px-2 align-items-center">
                      <div class="form-control" style="background-color: lightgreen;">
                        {{ paralisacao.pciModeloItemTermino ? paralisacao.pciModeloItemTermino.pais + ' > ' + paralisacao.pciModeloItemTermino.descricao : '' }}
                      </div>
                    </div>
                  </div>
                  <div style="width: 50px;" class="d-flex justify-content-center align-items-center px-2">
                    <div class="d-flex justify-items-center align-items-center">
                      <i style="font-size: 15px;" @click="onRemoveItem(index)" class="fas fa-trash text-danger pointer"></i>
                    </div>
                  </div>
                </div>
                <div class="d-flex col-md-12 p-0 m-0">
                  <div class="d-flex flex-grow-1">
                    <div class="d-flex flex-wrap col-md-6 p-0 px-2">
                      <div class="d-flex col-md-12 p-0 align-items-start w-100">
                        <div class="d-flex align-items-center w-100">
                          <b-form-input class="mr-1" disabled v-model="getStartWorkDescription"></b-form-input>
                          <i style="font-size: 15px; cursor: pointer;"
                            class="fas fa-search text-third"
                            v-if="!showStartWorkTreeview"
                            @click="onShowStartWorkTreeview"
                            v-b-tooltip.hover :title="$lang.PCI.Items.SearchItem"></i>
                          <i style="font-size: 15px; cursor: pointer;"
                            class="fas fa-times text-third"
                            v-if="showStartWorkTreeview"
                            @click="showStartWorkTreeview = false"
                            v-b-tooltip.hover :title="$lang.Common.Cancel"></i>
                        </div>
                      </div>
                      <div style="height: 500px;" class="mt-1" v-show="showStartWorkTreeview">
                        <item-tree-view ref="startWorkTreeview"
                                        :list="form.pciModeloItemIDInicioObra.options"
                                        :serializer="it => it.name"
                                        v-on:selectitem="onSelectStartWorkItem" />
                      </div>
                    </div>
                    <div class="d-flex flex-wrap col-md-6 p-0 px-2">
                      <div class="d-flex col-md-12 p-0 align-items-start w-100">
                        <div class="d-flex align-items-center w-100">
                          <b-form-input class="mr-1" disabled v-model="getEndWorkDescription"></b-form-input>
                          <i style="font-size: 15px; cursor: pointer;"
                            class="fas fa-search text-third"
                            v-if="!showEndWorkTreeview"
                            @click="onShowEndWorkTreeview"
                            v-b-tooltip.hover :title="$lang.PCI.Items.SearchItem"></i>
                          <i style="font-size: 15px; cursor: pointer;"
                            class="fas fa-times text-third"
                            v-if="showEndWorkTreeview"
                            @click="showEndWorkTreeview = false"
                            v-b-tooltip.hover :title="$lang.Common.Cancel"></i>
                        </div>
                      </div>
                      <div style="height: 500px;" class="mt-1" v-show="showEndWorkTreeview">
                        <item-tree-view ref="endWorkTreeview"
                                        :list="form.pciModeloItemIDTerminoObra.options"
                                        :serializer="it => it.name"
                                        v-on:selectitem="onSelectEndWorkItem" />
                      </div>
                    </div>
                  </div>
                  <div style="width: 50px;" class="d-flex justify-content-center align-items-center px-2">
                    <div class="d-flex justify-items-center align-items-center">
                      <i style="font-size: 15px;" class="fas fa-plus text-primary pointer" v-if="form.pciModeloItemTerminoObra.value && form.pciModeloItemInicioObra.value" @click="onAddItem"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Cálculo -->
            <div class="d-flex flex-wrap col-md-12" v-if="form.tipo.value === 12">
              <div class="col-md-2 mb-3 px-0">
                <label>{{ 'Formato' }}</label>
                <b-form-select v-model="form.calcFormato.value"
                               :options="form.calcFormato.options"
                               :required="form.calcFormato.required"
                               :state="form.calcFormato.state">
                </b-form-select>
              </div>
              <div class="col-md-10 pr-0">
                <label>{{ 'Expressão' }} <i class="fas fa-question-circle text-primary pointer" @click="showCalcHelp = !showCalcHelp"></i></label>
                <b-form-input v-model="form.calcExpressao.value"
                              :required="form.calcExpressao.required"
                              :state="form.calcExpressao.state">
                </b-form-input>
              </div>
              <div class="d-flex col-md-12 align-items-center mt-1" v-if="showCalcHelp" >
                <b-card :header="'Funções'" class="w-100">
                  <ul>
                    <li>
                      <h6 style="font-weight: bold;">Hoje()</h6>
                      <p>Retorna a data atual.</p>
                    </li>
                    <li>
                      <h6 style="font-weight: bold;">DiasEntre(DataInicial, DataFinal)</h6>
                      <p>Retorna a quantidade dias entre duas datas. Caso a data inicial seja maior que a data final, o retorno será um valor negativo.</p>
                    </li>
                    <li>
                      <h6 style="font-weight: bold;">AdicDias(Data, Dias)</h6>
                      <p>Retorna a data, adicionando-se a quantidade de dias informada.</p>
                    </li>
                    <li>
                      <h6 style="font-weight: bold;">Arred(Valor, Casas)</h6>
                      <p>Retorna o valor arredondado, considerando a quantidade de casas informado.</p>
                    </li>
                  </ul>
                </b-card>
              </div>
              <div class="d-flex col-md-12 align-items-center">
                <label>{{ 'Variáveis' }}</label>
                <i style="font-size: 15px; cursor: pointer;"
                   class="far fa-plus-square pl-3 pb-1 text-third"
                   v-if="!showCalcTreeview"
                   @click="showCalcTreeview = true"
                   v-b-tooltip.hover :title="$lang.PCI.Items.SearchItem">
                </i>
                <i style="font-size: 15px; cursor: pointer;"
                   class="fas fa-times pl-3 pb-1 text-third"
                   v-if="showCalcTreeview"
                   @click="showCalcTreeview = false"
                   v-b-tooltip.hover :title="$lang.Common.Cancel">
                </i>
              </div>
              <div class="d-flex align-items-center col-md-12" v-for="(vari, index) in form.calcVariaveis.value" :key="index">
                <div class="col-md-3 p-1">
                  <b-form-input v-model="vari.nome"></b-form-input>
                </div>
                <b-form-input class="mr-3 pb-1" disabled v-model="vari.text"></b-form-input>
                <i style="font-size: 15px; cursor: pointer;"
                   class="fas fa-trash px-3 pb-1 text-danger"
                   @click="onRemoveCalcVar(index)"
                   v-b-tooltip.hover :title="$lang.Common.Cancel">
                </i>
              </div>
              <div style="min-width: 500px;" class="d-flex mt-1" v-if="showCalcTreeview">
                <b-tabs class="w-100">
                  <b-tab>
                    <template #title><i class="fas fa-list"></i> {{ $lang.PCI.Reports.Item.ItemType0 }}</template>
                    <div id="modalCompareItems" class="d-flex flex-column align-items-center">
                      <item-tree-view ref="calcTreeview"
                                      :list="form.calcVariaveis.options"
                                      :serializer="it => `(${it.code}) ${it.name}`"
                                      v-on:selectitem="onSelectCalcVar" />
                    </div>
                  </b-tab>
                  <b-tab>
                    <template #title><i class="fas fa-thumbtack"></i> {{ $lang.PCI.Reports.Item.ItemType1 }}</template>
                    <div v-for="item in form.pciItemFixo.options" :key="item.code">
                      <div class="mt-2" v-if="(item.code % 10) === 0">
                        <strong>{{ item.text }}</strong>
                      </div>
                      <div v-else>
                        <a href="#" class="text-secondary ml-3" @click="onSelectCalcVarFixedItem(item)">{{ item.text }}</a>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>

            <!-- Totaliza Coluna -->
            <div class="d-flex col-md-3 mb-3 align-items-end"
                 v-if="(form.tipo.value === 0 && form.tipoDados.value === 4) || form.tipo.value === 2 || form.tipo.value === 4 || form.tipo.value === 5 || form.tipo.value === 9">
              <b-form-group>
                <b-form-checkbox v-model="form.totalizarColuna.value"
                                 name="chkTotalize"
                                 :required="form.totalizarColuna.required"
                                 :state="form.totalizarColuna.state"
                                 switch>
                  {{$lang.PCI.Items.LabelTotalizeColumn}}
                </b-form-checkbox>
              </b-form-group>
            </div>
          </b-tab>
          <b-tab ref="tabAutomations" :title="$lang.PCI.Items.Tabs.Automations" :disabled="!(form.codigo.value > 0 && form.tipo.value === 0 && form.tipoDados.value === 6)">
            <add-automation ref="addAutomation" :value="data" :itemList="itemList" v-if="selectedTab === 1 && form.codigo.value > 0 && form.tipo.value === 0 && form.tipoDados.value === 6">
            </add-automation>
          </b-tab>
          <b-tab ref="tabValidations" :title="$lang.PCI.Items.Tabs.Validations" :disabled="!(form.codigo.value > 0 && form.tipo.value !== 1)">
            <add-validation ref="addValidation" :value="data" :itemList="itemList" v-if="selectedTab === 2 && form.codigo.value > 0 && form.tipo.value !== 1">
            </add-validation>
          </b-tab>
        </b-tabs>
      </div>
      <template #button>
        <!-- <button type="button" v-if="form.codigo.value > 0 && selectedTab === 1" class="btn btn-third btn-sm" v-on:click="onSaveAutomation"><i class="fa fa-check-circle"></i> {{'Gravar Automatização'}}</button>&nbsp; -->
        <!-- <button type="button" v-if="form.codigo.value > 0 && selectedTab === 2" class="btn btn-third btn-sm" v-on:click="onSaveValidation"><i class="fa fa-check-circle"></i> {{'Gravar Validação'}}</button>&nbsp; -->
      </template>
    </forms>
  </div>
</template>

<script>
import PCIItemRepository from '@/shared/http/repositories/pci/pciItem'
import ServiceAnalysisTecRepository from '@/shared/http/repositories/pci/tecserviceanalysis'
import WorkPCIRepository from '@/shared/http/repositories/pci/workpci'
import ActionsForm from '@/shared/mixins/actionsForm'
import pcimodeloitem from '@/shared/models/pci/pcimodeloitemmodel'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import itemTreeView from '../components/treeview/ItemTreeView.vue'
import itemMixin from '../mixins/itemMixim'
import AddAutomation from './addAutomation.vue'
import AddValidation from './addValidation.vue'
import AddValidationAutomation from './addValidationAutomation.vue'
import itemForm from './item-form'

export default {
  name: 'AddItems',
  mixins: [ActionsForm, CompanyMixin, itemMixin],
  components: {
    itemTreeView,
    AddValidation,
    AddValidationAutomation,
    AddAutomation
  },
  data () {
    return {
      data: pcimodeloitem,
      form: itemForm,
      itemList: [],
      newValue: null,
      newFormula: null,
      newFormulaSmart: null,
      newServiceTecAn: null,
      father: null,
      itemsAddSelected: [],
      itemsRemoveSelected: [],
      showMirrorTreeview: false,
      showCondMirrorTreeview: false,
      showStartWorkTreeview: false,
      showEndWorkTreeview: false,
      showCalcTreeview: false,
      showCalcHelp: false,
      editAutomation: null,
      editValidation: null,
      used: false,
      selectedTab: 0
    }
  },
  computed: {
    getMirrorDescription () {
      if (this.data.pciModeloItemIDEspelho) {
        const pciModeloItemEspelho = this.form.pciModeloItemEspelho.value
        return pciModeloItemEspelho ? pciModeloItemEspelho.pais + ' > ' + pciModeloItemEspelho.descricao : ''
      }
    },
    getMirrorCondDescription () {
      if (this.data.pciModeloItemIDEspelhoCond) {
        const pciModeloItemEspelhoCond = this.form.pciModeloItemEspelhoCond.value
        return pciModeloItemEspelhoCond ? pciModeloItemEspelhoCond.pais + ' > ' + pciModeloItemEspelhoCond.descricao : ''
      }
    },
    getStartWorkDescription () {
      if (this.data.pciModeloItemIDInicioObra) {
        const pciModeloItemInicioObra = this.form.pciModeloItemInicioObra.value
        return pciModeloItemInicioObra ? pciModeloItemInicioObra.pais + ' > ' + pciModeloItemInicioObra.descricao : ''
      }
    },
    getEndWorkDescription () {
      if (this.data.pciModeloItemIDTerminoObra) {
        const pciModeloItemTerminoObra = this.form.pciModeloItemTerminoObra.value
        return pciModeloItemTerminoObra ? pciModeloItemTerminoObra.pais + ' > ' + pciModeloItemTerminoObra.descricao : ''
      }
    }
  },
  methods: {
    onClearForm () {
      this.onClear()
      this.$emit('back')
    },
    onLoad () {
    },
    onEditForm (obj, itemList) {
      this.form.tipo.value = 0
      this.form.resumo.value = false
      this.form.itemLinhaPrincipal.value = false
      this.form.itemFinanc.value = false
      this.form.calcFormato.value = 0
      this.form.valores.value = []
      this.itemList = itemList
      this.form.pciModeloItemIDEspelhoCond.required = false
      if (obj !== undefined && obj !== null) {
        this.form.pciModeloItemIDEspelhoCond.required = obj.tipoEspelho === 1
        this.onEdit(obj)
      }
      this.onLoadServiceAt()
      this.onLoadPCIModeloItem()
      this.onLoadPCIModeloItemEspelho()
      this.onLoadPCIModeloItemEspelhoCond()
      this.onLoadPCIModeloItemDic()
      this.onLoadPCIModeloItemCalc()
    },
    onCreate () {
      if (!this.onValidate()) {
        return
      }
      this.data.pciModeloItemIDPai = this.father ? this.father.id : null
      this.data.totalizarColuna = Boolean(this.form.totalizarColuna.value)
      this.data.empresaID = this.company.id

      loading.push()
      PCIItemRepository.Create(this.data)
        .then(response => {
          if (response.data.code > 0) {
            const data = {
              id: response.data.data.id,
              name: response.data.data.descricao,
              value: response.data.data.codigo,
              parentId: response.data.data.itemPaiID,
              type: response.data.data.tipo,
              dataType: response.data.data.tipoDados,
              order: response.data.data.ordem,
              open: false,
              children: response.data.data.tipo === 1 ? [] : null
            }
            if (this.father) this.father.children.push(data)
            else this.father = data
            this.$emit('create', this.father)
            toast.success(this.$lang.Common.Alerts.Success)
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => {
          console.log(err)
          this.onException(err)
        })
        .finally(() => loading.close())
    },
    onUpdate () {
      if (!this.onValidate()) {
        toast.warning(this.$lang.Common.Alerts.RequiredField)
        return
      }
      loading.push()
      PCIItemRepository.Update(this.data)
        .then(response => {
          if (response.data.code > 0) {
            this.$emit('update', response.data.data)
            toast.success(this.$lang.Common.Alerts.Success)
          } else if (response.data.message !== null && response.data.message !== '' && response.data.message !== undefined) {
            toast.error(response.data.message)
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
          loading.close()
        })
        .catch(err => {
          console.log(err)
          this.onException(err)
        })
        .finally(() => {
          loading.close()
          WorkPCIRepository.AutomatizationByItem(this.data.id)
          WorkPCIRepository.ValidationByItem(this.data.id)
        })
    },
    onValidate () {
      let result = true
      if (this.data.tipo === 5) {
        if (this.form.tipoAT.value === null) {
          this.$refs.selectTipoAT.$el.focus()
          return false
        }
        if (this.form.servicosAt.value.length === 0) {
          this.$refs.selectServiceAT.$el.focus()
          return false
        }
      }
      if (this.data.tipo === 12) {
        let valid = true
        if (this.form.calcVariaveis.value.some(cv => !cv.nome || cv.nome.includes(' '))) {
          toast.warning('Nome de variável inválido')
          valid = false
        }
        this.form.calcVariaveis.value.forEach(cv => {
          if (!this.form.calcExpressao.value || !this.form.calcExpressao.value.includes(cv.nome)) {
            toast.warning(`Variável ${cv.nome} não encontrada na expressão`)
            valid = false
          }
          if (this.form.calcVariaveis.value.filter(cv2 => cv2.pciModeloItemIDVar !== cv.pciModeloItemIDVar).some(cv2 => cv2.nome === cv.nome)) {
            toast.warning('Existem variáveis com o mesmo nome')
            valid = false
          }
        })
        return valid
      }
      return result
    },
    onSaveForm () {
      if (this.form.tipo.value === 2) {
        this.form.formula.value = []
        if (this.form.dfdID.value) {
          this.form.formula.value = [{
            id: this.data.formula && this.data.formula.length ? this.data.formula[0].id : '00000000-0000-0000-0000-000000000000',
            pciModeloItemID: this.data.id || '00000000-0000-0000-0000-000000000000',
            dfdID: this.form.dfdID.value,
            status: 1
          }]
        }
      }
      this.form.tipoEspelho.value = this.form.tipoEspelho.value || 0
      this.form.tipoEspelhoCond.value = this.form.tipoEspelhoCond.value || 0

      this.onSave()
    },
    // onSaveAutomation () {
    //   this.$refs.addAutomation.save()
    //     .finally(() => {
    //       loading.close()
    //       WorkPCIRepository.AutomatizationByItem(this.data.id)
    //       WorkPCIRepository.ValidationByItem(this.data.id)
    //     })
    // },
    onSaveValidation () {
      this.$refs.addValidation.save()
        .finally(() => {
          loading.close()
          WorkPCIRepository.ValidationByItem(this.data.id)
        })
    },
    getDFDName (id) {
      this.dfd.forEach(item => {
        if (item.id === id) {
          return item.nome
        }
      })
    },
    onAddValue () {
      if (!this.newValue || !this.newValue.length) return

      const arr = [...this.form.valores.value]
      arr.push({
        valor: this.newValue,
        pciModeloItemID: this.data.id || '00000000-0000-0000-0000-000000000000',
        status: 1
      })
      this.form.valores.value = arr.sort((a1, a2) => a1.valor < a2.valor ? -1 : a1.valor > a2.valor ? 1 : 0)
      this.newValue = null
    },
    onAddValueColor (value) {
      this.$set(value, 'cor', '#FFFFFF')
      this.$set(value, 'fonteClara', false)
    },
    onRemoveValueColor (value) {
      this.$set(value, 'cor', null)
    },
    onAddServiceTecAn () {
      if (!this.newServiceTecAn) return

      const srv = this.form.servicosAt.options.filter(s => s.id === this.newServiceTecAn)[0]
      const arr = this.form.servicosAt.value ? [...this.form.servicosAt.value] : []
      const opt = this.form.servicosAt.options.filter(s => s.id !== srv.id)
      arr.push({
        servicoAnaliseTecID: this.newServiceTecAn,
        servicoAnaliseTec: srv,
        pciModeloItemID: this.data.id ? this.data.id : '00000000-0000-0000-0000-000000000000',
        status: 1
      })
      this.form.servicosAt.value = arr
      this.form.servicosAt.options = opt
      this.newServiceTecAn = null
    },
    onRemoveServiceTecAn (index) {
      this.form.servicosAt.value.splice(index, 1)
      this.form.servicosAt.options = this.form.servicosAt.initial.filter(init => this.form.servicosAt.value && !this.form.servicosAt.value.some(vl => vl.servicoAnaliseTecID === init.id))
    },
    onAddFormula () {
      if (!this.newFormula) return

      const dfd = this.form.dfdID.options.filter(d => d.id === this.newFormula)[0]
      const arr = this.form.formula.value ? [...this.form.formula.value] : []
      arr.push({
        dfdid: this.newFormula,
        dfd: dfd,
        pciModeloItemID: this.data.id ? this.data.id : '00000000-0000-0000-0000-000000000000',
        status: 1
      })
      this.form.formula.value = arr
      this.newFormula = null
    },
    onRemoveFormula (index) {
      this.form.formula.value.splice(index, 1)
    },
    onAddFormulaSmart () {
      if (!this.newFormulaSmart) return

      const dic = this.form.pciDicItemID.options.filter(d => d.id === this.newFormulaSmart)[0]
      const arr = this.form.formulaSmart.value ? [...this.form.formulaSmart.value] : []
      arr.push({
        pciDicItemID: this.newFormulaSmart,
        nome: dic.nome,
        pciModeloItemID: this.data.id ? this.data.id : '00000000-0000-0000-0000-000000000000',
        status: 1
      })
      this.form.formulaSmart.value = arr
      this.newFormulaSmart = null
    },
    onRemoveFormulaSmart (index) {
      this.form.formulaSmart.value.splice(index, 1)
    },
    onRemoveValue (index) {
      this.form.valores.value.splice(index, 1)
    },
    onAddItem () {
      const item = {
        pciModeloItemID: this.data.id,
        pciModeloItemInicioID: this.form.pciModeloItemInicioObra.value.id,
        pciModeloItemInicio: this.form.pciModeloItemInicioObra.value,
        pciModeloItemTerminoID: this.form.pciModeloItemTerminoObra.value.id,
        pciModeloItemTermino: this.form.pciModeloItemTerminoObra.value
      }
      this.form.paralisacoes.value.push(item)
      this.form.pciModeloItemInicioObra.value = null
      this.form.pciModeloItemTerminoObra.value = null
    },
    onRemoveItem (index) {
      this.form.paralisacoes.value.splice(index, 1)
    },
    addComposto () {
      const items = this.form.children.value ? [...this.form.children.value] : []
      let ordem = items && items.length ? Math.max.apply(Math, items.map(i => i.ordem)) : 0
      items.push(...this.itemsAddSelected.map(i => {
        i.pciModeloItemIDPai = this.data.id
        i.ordem = ++ordem
        return i
      }))
      items.sort((i1, i2) => i1.ordem < i2.ordem ? -1 : i1.ordem > i2.ordem ? 1 : 0)
      this.form.children.value = items
      this.form.children.options = [...this.form.children.options.filter(i => this.itemsAddSelected.every(s => s.id !== i.id))]
    },
    removeComposto () {
      const items = [...this.form.children.options]
      let ordem = items && items.length ? Math.max.apply(Math, items.map(i => i.ordem)) : 0
      items.push(...this.itemsRemoveSelected.map(i => {
        i.pciModeloItemIDPai = null
        i.pciModeloItemPai = null
        i.ordem = ++ordem
        return i
      }))
      items.sort((i1, i2) => i1.ordem < i2.ordem ? -1 : i1.ordem > i2.ordem ? 1 : 0)
      this.form.children.options = items
      this.form.children.value = [...this.form.children.value.filter(i => this.itemsRemoveSelected.every(s => s.id !== i.id))]
    },
    onCreateAutomation (automation) {
      this.editAutomation.regrasStatus.push(automation)
    },
    onShowMirrorTreeview () {
      this.showMirrorTreeview = true
      this.$nextTick(() => {
        this.$refs.mirrorTreeview.setSelected(this.form.pciModeloItemEspelho.value)
      })
    },
    onSelectMirrorItem (item) {
      if (item.type === 1) {
        toast.warning(this.$lang.PCI.Items.Alerts.CannotSelectCompositeItem)
        return
      }
      if (item.type === 3) {
        toast.warning(this.$lang.PCI.Items.Alerts.CannotSelectMirrorItem)
        return
      }

      loading.push()
      this.showMirrorTreeview = false
      PCIItemRepository.Find(item.id)
        .then(response => {
          if (response.data.code > 0) {
            this.form.pciModeloItemIDEspelho.value = response.data.data.id
            this.form.pciModeloItemEspelho.value = response.data.data
            this.data.pciModeloItemIDEspelho = response.data.data.id
          } else {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onSelectCalcVar (vari) {
      if (vari.type === 1) {
        toast.warning(this.$lang.PCI.Items.Alerts.CannotSelectCompositeItem)
        return
      }
      if (vari.type === 12) {
        toast.warning(this.$lang.PCI.Items.Alerts.CannotSelectCalcItem)
      }
      if (vari.id === this.data.id) {
        return
      }
      if (!this.form.calcVariaveis.value) this.form.calcVariaveis.value = []
      this.form.calcVariaveis.value.push({
        id: '00000000-0000-0000-0000-000000000000',
        nome: '',
        pciModeloItemIDVar: vari.id,
        pciModeloItemID: this.data.id || '00000000-0000-0000-0000-000000000000',
        pciItemFixoVar: null,
        text: `(${vari.code}) ${vari.name}`
      })
      this.showCalcTreeview = false
    },
    onSelectCalcVarFixedItem (item) {
      if (item) {
        const fatherId = parseInt(item.code / 10) * 10
        const prefix = this.form.pciItemFixo.options.filter(fi => fi.code === fatherId)[0].text

        this.form.pciItemFixo.parents = prefix + ' > ' + this.form.pciItemFixo.options.filter(fi => fi.code === item.code)[0].text
        if (!this.form.calcVariaveis.value) this.form.calcVariaveis.value = []
        this.form.calcVariaveis.value.push({
          id: '00000000-0000-0000-0000-000000000000',
          nome: '',
          pciModeloItemIDVar: null,
          pciModeloItemID: this.data.id || '00000000-0000-0000-0000-000000000000',
          pciItemFixoVar: item.code,
          text: `${prefix} > ${item.text}`
        })
        this.showCalcTreeview = false
      }
    },
    onRemoveCalcVar (index) {
      this.form.calcVariaveis.value.splice(index, 1)
    },
    onShowCondMirrorTreeview () {
      this.showCondMirrorTreeview = true
      this.$nextTick(() => {
        this.$refs.condMirrorTreeview.setSelected(this.form.pciModeloItemEspelhoCond.value)
      })
    },
    onSelectCondMirrorItem (item) {
      if (item.type === 1) {
        toast.warning(this.$lang.PCI.Items.Alerts.CannotSelectCompositeItem)
        return
      }
      if (item.type === 3) {
        toast.warning(this.$lang.PCI.Items.Alerts.CannotSelectMirrorItem)
        return
      }

      loading.push()
      this.showCondMirrorTreeview = false
      PCIItemRepository.Find(item.id)
        .then(response => {
          if (response.data.code > 0) {
            this.form.pciModeloItemIDEspelhoCond.value = response.data.data.id
            this.form.pciModeloItemEspelhoCond.value = response.data.data
            this.data.pciModeloItemIDEspelhoCond = response.data.data.id
          } else {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onShowStartWorkTreeview () {
      this.showStartWorkTreeview = true
      this.$nextTick(() => {
        this.$refs.startWorkTreeview.setSelected(this.form.pciModeloItemInicioObra.value)
      })
    },
    onSelectStartWorkItem (item) {
      if (!(item.type === 0 && item.dataType === 1)) {
        console.log(item)
        toast.warning('Só é permitido item do tipo Data')
        return
      }

      loading.push()
      this.showStartWorkTreeview = false
      PCIItemRepository.Find(item.id)
        .then(response => {
          if (response.data.code > 0) {
            this.form.pciModeloItemIDInicioObra.value = response.data.data.id
            this.form.pciModeloItemInicioObra.value = response.data.data
            this.data.pciModeloItemIDInicioObra = response.data.data.id
          } else {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onShowEndWorkTreeview () {
      this.showEndWorkTreeview = true
      this.$nextTick(() => {
        this.$refs.endWorkTreeview.setSelected(this.form.pciModeloItemTerminoObra.value)
      })
    },
    onSelectEndWorkItem (item) {
      if (!(item.type === 0 && item.dataType === 1)) {
        console.log(item)
        toast.warning('Só é permitido item do tipo Data')
        return
      }

      loading.push()
      this.showEndWorkTreeview = false
      PCIItemRepository.Find(item.id)
        .then(response => {
          if (response.data.code > 0) {
            this.form.pciModeloItemIDTerminoObra.value = response.data.data.id
            this.form.pciModeloItemTerminoObra.value = response.data.data
            this.data.pciModeloItemIDTerminoObra = response.data.data.id
          } else {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onLoadServiceAt () {
      ServiceAnalysisTecRepository.GetAll(1000, 1)
        .then(response => {
          if (response.data.code > 0) {
            this.form.servicosAt.initial = response.data.data
            this.form.servicosAt.options = this.form.servicosAt.initial.filter(init => !this.form.servicosAt.value || !this.form.servicosAt.value.some(vl => vl.servicoAnaliseTecID === init.id))
          }
        })
        .catch(err => console.log(err))
    },
    onLoadPCIModeloItem () {
      const list = this.itemList.map(item => {
        return {
          parentId: item.itemPaiID,
          name: item.descricao,
          code: item.codigo,
          type: item.tipo,
          dataType: item.tipoDados,
          id: item.id
        }
      })
      this.form.pciModeloItemIDEspelho.options = this.getHierarchy(list)
      this.form.pciModeloItemIDEspelhoCond.options = this.getHierarchy(list)
      this.form.pciModeloItemIDInicioObra.options = this.getHierarchy(list)
      this.form.pciModeloItemIDTerminoObra.options = this.getHierarchy(list)
      this.form.calcVariaveis.options = this.getHierarchy(list)
    },
    onLoadPCIModeloItemEspelho () {
      if (this.data.tipo === 3) {
        loading.push()
        PCIItemRepository.Find(this.data.pciModeloItemIDEspelho)
          .then(response => {
            if (response.data.code > 0) {
              this.form.pciModeloItemEspelho.value = response.data.data
            }
          })
          .finally(() => loading.close())
      }
    },
    onLoadPCIModeloItemEspelhoCond () {
      if (this.data.tipo === 3 && this.data.tipoEspelho === 1) {
        loading.push()
        PCIItemRepository.Find(this.data.pciModeloItemIDEspelhoCond)
          .then(response => {
            if (response.data.code > 0) {
              this.form.pciModeloItemEspelhoCond.value = response.data.data
            }
          })
          .finally(() => loading.close())
      }
    },
    onLoadPCIModeloItemDic () {
      if (!this.form.formulaSmart.value) return

      this.form.formulaSmart.value.forEach(itemDic => {
        itemDic.nome = this.form.pciDicItemID.options.filter(it => it.id === itemDic.pciDicItemID)[0].nome
      })
    },
    onLoadPCIModeloItemCalc () {
      if (this.data.tipo === 12 && this.form.calcVariaveis.value) {
        this.form.calcVariaveis.value.forEach(cv => {
          if (cv.pciModeloItemIDVar) {
            const item = this.itemList.filter(it => it.id === cv.pciModeloItemIDVar)[0]
            cv.text = `(${item.codigo}) ${item.descricao}`
          } else {
            const fatherId = parseInt(cv.pciItemFixoVar / 10) * 10
            const prefix = this.form.pciItemFixo.options.filter(fi => fi.code === fatherId)[0].text

            cv.text = prefix + ' > ' + this.form.pciItemFixo.options.filter(fi => fi.code === cv.pciItemFixoVar)[0].text
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.text-third-reverse {
  background-color: #008144;
  color: white;
}
div.action-buttons {
  display: none;
}
#values:hover > div.action-buttons {
  display: flex;
}
#values {
  padding-bottom: 0.2em;
}
div[role='radiogroup'] >>> .custom-radio {
  margin-right: 0.5rem
}
.tab-pane {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/items/additems.vue